import React from 'react';
import { useTranslation } from 'react-i18next';
import { privacyContent } from '../../data/privacyContent';
import './style.css';

const Privacy = () => {
    const { i18n } = useTranslation();
    const content = privacyContent[i18n.language] || privacyContent.en; 

    console.log('Privacy content:', content); // Debug log

    return (
        <div className="privacy-container section-padding">
            <div className="container">
                <div className="privacy-content">
                    <h1>{content.title}</h1>
                    <p className="last-updated">{content.lastUpdated}</p>
                    <div className="privacy-sections">
                        {content.sections && content.sections.map((section, index) => (
                            <section key={index} className="privacy-section">
                                <h2>{section.title}</h2>
                                <div className="section-content">
                                    {section.content && <p>{section.content}</p>}
                                    {section.list && (
                                        <ul className="privacy-list">
                                            {section.list.map((item, i) => (
                                                <li key={i}>{item}</li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            </section>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Privacy;
